export class Texture {
  static fromElement(gl: WebGLRenderingContext, element: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement): Texture {
    const texture = new Texture(gl, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE);
    texture.loadContentsOf(element);
    return texture;
  }

  public gl: WebGLRenderingContext;
  private id: WebGLTexture | null;
  width: number;
  height: number;
  format: number;
  type: number;

  constructor(gl: WebGLRenderingContext, width: number, height: number, format: number, type: number) {
    this.gl = gl;
    this.id = gl.createTexture();
    this.width = width;
    this.height = height;
    this.format = format;
    this.type = type;

    gl.bindTexture(gl.TEXTURE_2D, this.id);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    if (width && height) {
      gl.texImage2D(gl.TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
    }
  }

  loadContentsOf(element: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement): void {
    const gl = this.gl;
    this.width = element.width || (element as HTMLVideoElement).videoWidth;
    this.height = element.height || (element as HTMLVideoElement).videoHeight;
    gl.bindTexture(gl.TEXTURE_2D, this.id);
    gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, element);
  }

  destroy(): void {
    const gl = this.gl;
    if (this.id) {
      gl.deleteTexture(this.id);
      this.id = null;
    }
  }

  use(unit: number = 0): void {
    const gl = this.gl;
    gl.activeTexture(gl.TEXTURE0 + unit);
    gl.bindTexture(gl.TEXTURE_2D, this.id);
  }

  drawTo(callback: () => void): void {
    const gl = this.gl;
    // @ts-ignore
    if (!gl.framebuffer) {
      // @ts-ignore
      gl.framebuffer = gl.createFramebuffer();
    }
    // @ts-ignore
    gl.bindFramebuffer(gl.FRAMEBUFFER, gl.framebuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.id, 0);
    if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
      throw new Error('Incomplete framebuffer');
    }
    gl.viewport(0, 0, this.width, this.height);
    callback();
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  }

  swapWith(other: Texture): void {
    [this.id, other.id] = [other.id, this.id];
    [this.width, other.width] = [other.width, this.width];
    [this.height, other.height] = [other.height, this.height];
    [this.format, other.format] = [other.format, this.format];
  }
}
